import { usePageContext } from '#app/hooks/usePageContext.js';
import { type Location } from '#app/types/router.js';
import { useMemo } from 'react';

export const useLocation = (): Location => {
  const pageContext = usePageContext();

  const { pathname, searchOriginal } = pageContext.urlParsed;

  return useMemo(() => {
    let path = pathname;

    if (searchOriginal) {
      path += searchOriginal;
    }

    const origin =
      typeof window === 'undefined'
        ? pageContext.origin
        : // eslint-disable-next-line no-restricted-properties
          window.location.origin;

    const currentURL = new URL(path, origin);

    return {
      currentURL: currentURL.toString(),
      host: currentURL.host,
      origin,
      path,
      pathname,
      search: searchOriginal ? searchOriginal.slice(1) : '',
    };
  }, [pathname, searchOriginal, pageContext.origin]);
};
